import Vue from 'vue'
import {releaseChildOrders} from "@/api/adOrder";

//获取钉钉应用ID-用于扫码登录
/**
 *
 * @param data
 * @returns {*}
 */
export function getPukeList(data) {
    return Vue.axios({
        url: '/api/order/pukeList',
        method: 'get',
        params: {...data}
    })
}



// 订单详情-基本信息
export function getPukeDetailBase(data) {
    return Vue.axios({
        url: '/api/order/order_puke_detail',
        method: 'get',
        params: {...data,}

    })
}
export function savePukeDetailBase(data) {
    return Vue.axios({
        url: '/api/order/save_order_puke',
        method: 'post',
        data: {...data}
    })
}



export function delectPukeOrder(data) {
    return Vue.axios({
        url: '/api/order/delete_order_puke',
        method: 'get',
        params: {...data}
    })
}
//撤单
export function undoPukeOrder(data) {
    return Vue.axios({
        url: '/api/order/undo_order_puke',
        method: 'get',
        params: {...data}
    })
}
//获取子单
export function getPukeOrderChild(data) {
    return Vue.axios({
        url: '/api/order/orderPukeChildren',
        method: 'get',
        params: {...data}
    })
}
//关联子订单
export function appendPukeOrderChild(data) {
    return Vue.axios({
        url: '/api/order/appendChildOrdersByPuke',
        method: 'post',
        data: {...data}
    })
}
//释放子订单
export function releasePukeOrderChild(data) {
    return Vue.axios({
        url: '/api/order/releaseChildOrdersByPuke',
        method: 'post',
        data: {...data}
    })
}
//转移子订单
export function transferPukeOrderChild(data) {
    return Vue.axios({
        url: '/api/order/transferChildOrdersByPuke',
        method: 'post',
        data: {...data}
    })
}
//查询是否有订单
export function pidWithPukeOrder(data) {
    return Vue.axios({
        url: '/api/order/pidWithMarkPuke',
        method: 'get',
        params: {...data}
    })
}
export function getWithPukeProject(data) {
    return Vue.axios({
        url: '/api/order/getAimProjectPuke',
        method: 'get',
        params: {...data}
    })
}
export function getPukeOrderLogs(data) {
    return Vue.axios({
        url: '/api/order/getOrderLogsByPuke',
        method: 'get',
        params: {...data}
    })
}
